import React from 'react';
import { Box } from '@mui/material';

export default function CenteredProgress() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
        width: '100%',
        backgroundColor: '#050B07',
        gap: 3,
      }}
    >
      <img
        src="/images/fieldinspect-logo-white.svg"
        alt="FieldInspect"
        style={{ height: 28, opacity: 0.9 }}
      />
      <Box
        sx={{
          width: 32,
          height: 32,
          border: '3px solid rgba(95, 216, 132, 0.2)',
          borderTopColor: '#5FD884',
          borderRadius: '50%',
          animation: 'spin 0.8s linear infinite',
          '@keyframes spin': {
            to: { transform: 'rotate(360deg)' },
          },
        }}
      />
    </Box>
  );
}
